import { getUserID, getUser, makeFeedback } from '@/utils/requestHandler'
import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'
import Notification from '@/components/Notification/Notification.vue'

export default {
   name: 'Feedback',
   components: {
      BadRequest,
      Notification
   },
   data() {
      return {
         email: '',
         message: '',
         emailMessage: '',
         emailValid: null,
         textValid: null,
         userNameResponse: null,
         userName: '',
         userResponse: null,
         user: '',
         sender: 'sbcapi@sbcdc.ch',
         receiver: 'Support.SBCOss@swisscom.com',
         feedbackSubject: 'Feedback zu SBCGo!',
         requestProcessing: false,
         error: null
      }
   },
   async created() {
      this.userNameResponse = await getUserID()
      if (typeof this.userNameResponse == 'string') {
         if (this.userNameResponse.includes('Request failed') || this.userNameResponse.toLowerCase().includes('error')) {
            this.error = this.userNameResponse
            console.log(this.error)
            this.loading = false
         }
      }
      this.userName = this.userNameResponse.name

      this.userResponse = await getUser(this.userName)
      if (typeof this.userResponse == 'string') {
         if (this.userResponse.includes('Request failed') || this.userResponse.toLowerCase().includes('error')) {
            this.error = this.userResponse
            console.log(this.error)
            this.loading = false
         }
      }
      this.user = this.userResponse
         .split(' ')
         .reverse()
         .join(' ')
   },
   methods: {
      selectEmail(selection) {
         this.email = selection
      },
      isEmailValid() {
         var emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
         this.emailValid = emailPattern.test(this.email)
      },
      selectMessage(selection) {
         this.message = selection
      },
      isMessageValid() {
         var messagePattern = /^[-a-zA-Z0-9àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ",.:'?!()+=%/*&\n]+$/g
         var messageArray = this.message.split('')
         if (messageArray.length <= 2500 && messagePattern.test(this.message)) {
            this.textValid = true
         } else {
            this.textValid = false
         }
      },

      createMessage() {
         this.emailMessage =
            'Hallo Zusammen \n' +
            '\n' +
            this.message +
            '\n' +
            '\n Meine E-Mailadresse lautet: ' +
            this.email +
            '\n' +
            '\n Freundliche Grüsse ' +
            this.user
         console.log(this.emailMessage)
      },

      sendFeedback() {
         console.log('Checking form...')

         this.isEmailValid()
         this.isMessageValid()

         if (this.emailValid && this.textValid) {
            console.log('Form is valid...')

            this.createMessage()

            if (!this.requestProcessing) {
               this.requestProcessing = true
               this.createFeedback()
               console.log('Creating Sitepresence...')
            } else {
               console.log('Error - Problem with sending the Feedback!')
            }
         } else {
            console.log('Form is not valid...')
         }
      },
      buildFeedback() {
         return {
            from: this.sender,
            to: this.receiver + ', ' + this.email,
            subject: this.feedbackSubject,
            message: this.emailMessage,
            html: false
         }
      },
      createFeedback() {
         const feedback = this.buildFeedback()
         console.log(feedback)

         makeFeedback(feedback)
            .then(response => {
               if (response.status == 200) {
                  localStorage.setItem('showFeedbackMessage', true)
                  console.log('Feedback was sent.', response.data)
                  this.resetForm()
               } else {
                  if (response.includes('Request failed') || response.toLowerCase().includes('error')) {
                     this.error = response
                     console.log(this.error)
                  }
               }
               this.requestProcessing = false
            })
            .catch(e => {
               console.log(e)
            })
      },

      resetForm() {
         location.reload()
      }
   },
   mounted() {
      // Shows a logout message for 4sec
      if (localStorage.showFeedbackMessage) {
         localStorage.removeItem('showFeedbackMessage')
         setTimeout(() => {
            this.$refs.notification.show()
         }, 400)
         setTimeout(() => {
            this.$refs.notification.close()
         }, 4000)
      }
   }
}
